import { getLatestData } from '../Utils/GetLatestData'
import { WizardContext, WizardEvent } from '../wizardMachine'

export const isAssetPro = (context: WizardContext, event: WizardEvent): boolean => {
  const { asset } = getLatestData(context, event)
  if (asset) {
    if (asset.is_pro === true) {
      return true
    }
  }

  return false
}
